@if (tableData[retailMailOrderSwitch]) {
  <div class="mat-typography mat-body mat-app-background">
    <h2 class="drug-cost-header">{{ coverageHeading ? coverageHeading : defaultCoverageHeading }}</h2>
    @if (monthlyCostDescriptionContent) {
      <div class="monthly-cost-description" [innerHTML]="monthlyCostDescriptionContent"></div>
    }
    <div class="costTableContainer">
      <table class="costTable">
        @if (tableData[retailMailOrderSwitch].monthlyAfterDeductible.hasTopper) {
          <tr class="costHeading">
            <th></th>
            <th class="empty-cell"></th>
            @if (hasDeductibleColumn) {
              <th colspan="4">{{tableData[retailMailOrderSwitch].monthlyAfterDeductible.tableTop[0]}}</th>
            }
            @if (!hasDeductibleColumn) {
              <th colspan="3">{{tableData[retailMailOrderSwitch].monthlyAfterDeductible.tableTop[0]}}</th>
            }
            <th colspan="3">{{tableData[retailMailOrderSwitch].monthlyAfterDeductible.tableTop[1]}}</th>
          </tr>
        }
        <tr class="costHeading">
          <th class="empty-cell"></th>
          @for (header of tableData[retailMailOrderSwitch].monthlyAfterDeductible.headerRow; track header; let i = $index) {
            <th>
              {{header}}
            </th>
          }
        </tr>
        @for (drugRow of tableData[retailMailOrderSwitch].monthlyAfterDeductible.tableBody; track drugRow; let i = $index) {
          <tr>
            <td>
              {{drugRow.head}}
              <br>
                <p>{{drugRow.descript}}</p>
              </td>
              @for (drugCell of drugRow.row; track drugCell; let i = $index) {
                <td [innerHTML]="drugCell">
                </td>
              }
            </tr>
          }
        </table>
      </div>
      <div class="spacing"></div>
      <!---------------------------------------------------->
      <h2 class="drug-cost-header">{{ monthlyHeading ? monthlyHeading : defaultMonthTableHeading }}</h2>
      <div class="costTableContainer">
        <table class="costTable">
          @if (tableData[retailMailOrderSwitch].drug.hasTopper) {
            <tr class="costHeading">
              @for (topper of tableData[retailMailOrderSwitch].tableTop; track topper; let i = $index) {
                <th>{{topper}}</th>
              }
            </tr>
          }
          <tr class="costHeading">
            <th></th>
            @for (header of tableData[retailMailOrderSwitch].drug.headerRow; track header; let i = $index) {
              <th>
                {{header}}
              </th>
            }
          </tr>
          @for (drugRow of tableData[retailMailOrderSwitch].drug.tableBody; track drugRow; let i = $index) {
            <tr>
              <td>{{monthLabels[i] }}</td>
              @for (drugCell of drugRow.row; track drugCell; let i = $index) {
                <td [innerHTML]="drugCell">
                </td>
              }
            </tr>
          }
        </table>
      </div>
    </div>
  }
